import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Col, Row} from 'reactstrap'
import {graphql, compose, withApollo} from 'react-apollo'
import {getAvailableColumns} from '../../utils/columnUtils'
import {ElementsListQuery, WpsAndInspectionsDictionariesQuery} from '../Projects/mutations'
import BlockWithLoader from '../Support/BlockWithLoader'

class Step2ColumnSelection extends Component {
  static propTypes = {
    projectId: PropTypes.number.isRequired,
    selectedColumns: PropTypes.array.isRequired,
    onSelectedColumnsChange: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    client: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      inspection_category_types: null
    }
  }

  componentDidMount() {
    this.props.client.query({
      query: WpsAndInspectionsDictionariesQuery,
      fetchPolicy: 'network-only'
    }).then(({ data }) => {
      this.setState({ inspection_category_types: data.inspection_category_types })
    })
  }

  handleSelectAllColumns = (checked) => {
    const displayColumnIds = this.getDisplayColumns().map(col => col.id)
    if (checked) {
      // Add all display columns to selected
      const newSelected = [...new Set([...this.props.selectedColumns, ...displayColumnIds])]
      newSelected.forEach(id => this.props.onSelectedColumnsChange(id, 'selected_columns'))
    } else {
      // Remove all display columns from selected
      displayColumnIds.forEach(id => {
        if (this.props.selectedColumns.includes(id)) {
          this.props.onSelectedColumnsChange(id, 'selected_columns')
        }
      })
    }
  }

  handleSelectAllInspection = (inspectionFields, checked) => {
    const fieldIds = inspectionFields.map(field => field.id)
    if (checked) {
      // Add all inspection fields to selected
      const newSelected = [...new Set([...this.props.selectedColumns, ...fieldIds])]
      fieldIds.forEach(id => {
        if (!this.props.selectedColumns.includes(id)) {
          this.props.onSelectedColumnsChange(id, 'selected_columns')
        }
      })
    } else {
      // Remove all inspection fields from selected
      fieldIds.forEach(id => {
        if (this.props.selectedColumns.includes(id)) {
          this.props.onSelectedColumnsChange(id, 'selected_columns')
        }
      })
    }
  }

  getDisplayColumns = () => {
    const element = this.props.data.element
    const allColumns = getAvailableColumns(element, this.state.inspection_category_types)
    const elementColumn = { id: 'element', name: 'Element', type: 'default' }
    
    return [elementColumn, ...allColumns.filter(col => 
      col.type === 'default' || (element && element.extra_columns && col.id in JSON.parse(element.extra_columns || '{}'))
    )]
  }

  render() {
    if (this.props.data.loading || !this.state.inspection_category_types) {
      return <BlockWithLoader loading={true} renderChildren={true}><div>Loading columns...</div></BlockWithLoader>
    }

    const element = this.props.data.element
    const allColumns = getAvailableColumns(element, this.state.inspection_category_types)
    const displayColumns = this.getDisplayColumns()
    
    // Get inspection categories
    const inspectionColumns = allColumns.filter(col => col.id.startsWith('$inspections_'))
    
    // Divide columns into 4 equal chunks for vertical listing
    const columnsPerCol = Math.ceil(displayColumns.length / 4)
    const columnChunks = []
    for (let i = 0; i < 4; i++) {
      const start = i * columnsPerCol
      const end = start + columnsPerCol
      columnChunks.push(displayColumns.slice(start, end))
    }
    
    // Check if all display columns are selected
    const allDisplaySelected = displayColumns.every(col => this.props.selectedColumns.includes(col.id))
    
    return (
      <div>
        <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '10px'}}>
          <input 
            type="checkbox"
            id="select-all-columns"
            onChange={(e) => this.handleSelectAllColumns(e.target.checked)}
            checked={allDisplaySelected}
            style={{marginTop: '5px', marginRight: '8px'}}
          />
          <h6 style={{margin: 0, fontWeight: 'bold', cursor: 'pointer'}} onClick={() => this.handleSelectAllColumns(!allDisplaySelected)}>CHOOSE REPORT COLUMNS:</h6>
        </div>
        <Row>
          {columnChunks.map((chunk, colIndex) => (
            <Col md="3" key={colIndex}>
              {chunk.map((col, i) => (
                <div key={i} className="raportBox" style={{display: 'flex', alignItems: 'flex-start', marginBottom: '5px'}}>
                  <input 
                    type="checkbox"
                    id={col.id}
                    value={col.id}
                    onChange={(e) => {
                      this.props.onSelectedColumnsChange(e.target.value, 'selected_columns')
                    }}
                    checked={this.props.selectedColumns.includes(col.id)}
                    style={{marginTop: '5px', marginRight: '8px'}}
                  />
                  <label htmlFor={col.id} style={{margin: 0, cursor: 'pointer'}}>{col.name}</label>
                </div>
              ))}
            </Col>
          ))}
        </Row>
        
        {inspectionColumns.length > 0 && (
          <div style={{marginTop: '20px'}}>
            <Row>
              {inspectionColumns.map((inspCol, inspIndex) => {
                const inspectionFields = [
                  { id: `${inspCol.id}_test_date`, name: 'Test date' },
                  { id: `${inspCol.id}_range`, name: 'Range' },
                  { id: `${inspCol.id}_report`, name: 'Report' },
                  { id: `${inspCol.id}_tested_length`, name: 'Tested length' },
                  { id: `${inspCol.id}_percent`, name: 'Percent' },
                  { id: `${inspCol.id}_defected_length`, name: 'Defected length' },
                  { id: `${inspCol.id}_is_double_length`, name: 'Is double length' },
                  { id: `${inspCol.id}_acceptance`, name: 'Acceptance' },
                  { id: `${inspCol.id}_grouping`, name: 'Grouping' }
                ]
                
                const allInspectionSelected = inspectionFields.every(field => this.props.selectedColumns.includes(field.id))
                
                return (
                  <Col md="3" key={inspIndex}>
                    <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '10px'}}>
                      <input 
                        type="checkbox"
                        id={`select-all-${inspCol.id}`}
                        onChange={(e) => this.handleSelectAllInspection(inspectionFields, e.target.checked)}
                        checked={allInspectionSelected}
                        style={{marginTop: '5px', marginRight: '8px'}}
                      />
                      <h6 style={{margin: 0, fontWeight: 'bold', cursor: 'pointer'}} onClick={() => this.handleSelectAllInspection(inspectionFields, !allInspectionSelected)}>INSPECTIONS {inspCol.name}</h6>
                    </div>
                    {inspectionFields.map((field, fieldIndex) => (
                      <div key={fieldIndex} className="raportBox" style={{display: 'flex', alignItems: 'flex-start', marginBottom: '5px'}}>
                        <input 
                          type="checkbox"
                          id={field.id}
                          value={field.id}
                          onChange={(e) => {
                            this.props.onSelectedColumnsChange(e.target.value, 'selected_columns')
                          }}
                          checked={this.props.selectedColumns.includes(field.id)}
                          style={{marginTop: '5px', marginRight: '8px'}}
                        />
                        <label htmlFor={field.id} style={{margin: 0, cursor: 'pointer'}}>{field.name}</label>
                      </div>
                    ))}
                  </Col>
                )
              })}
            </Row>
          </div>
        )}
      </div>
    )
  }
}

const Step2ColumnSelectionWithData = graphql(ElementsListQuery, {
  options: (props) => ({
    fetchPolicy: 'network-only',
    variables: {
      parent_id: props.projectId
    }
  })
})(Step2ColumnSelection)

export default withApollo(Step2ColumnSelectionWithData)


// WEBPACK FOOTER //
// ./src/components/FinalReport/Step2ColumnSelection.js